import SuperFetchV2 from '../../../superFetchV2';
import {
  UserGradeHistoriesRequestOptionType,
  UserGradeHistoriesResponseType,
  UserGradesOptions,
  UserGradesResponseType,
  UserGradeSummaryResponseType,
} from '../../../../views/account/user/detail/AccountUserDetailGrade/types';
import queryString from 'query-string';
import {
  GetAccountUserListParameterType,
  UserListFilterOptionType,
} from '../../../../views/account/user/list/AccountUserList/types/options';
import {
  AccountUserListResponseType,
  DownloadExcelUserListResponseType,
} from '../../../../views/account/user/list/AccountUserList/types/accountUser';
import {
  MemberMigrationRequestOptionType,
  MemberMigrationResponseType,
} from '../../../../views/account/user/detail/AccountUserDetailUserInfo/UserInfoTrasferSection/types';
import { AccountUserDetailTypeV2 } from '../../../../views/account/user/detail/common/types/accountUserDetail';

export const AccountUserApiV2 = {
  /**
   *  [유저] 유저 등급 집계 정보 요청하기
   */
  getAccountUserDetailGradeSummary: (userId: number): Promise<UserGradeSummaryResponseType> =>
    SuperFetchV2.get(`/members/${userId}/grade-summary`),

  /**
   *  [유저] 유저 등급 리스트 정보 요청하기
   */
  getAccountUserGrades: (options: UserGradesOptions): Promise<UserGradesResponseType> => {
    const gradesOptionQueryString = queryString.stringify(options, { skipNull: true });
    return SuperFetchV2.get(`/member-grades/?${gradesOptionQueryString}`);
  },

  /**
   *  [유저] 유저 등급 히스토리 정보 요청하기
   */
  getUserGradeHistories: (
    userId: number,
    options: UserGradeHistoriesRequestOptionType,
  ): Promise<UserGradeHistoriesResponseType> => {
    const gradeHistoriesOptionQueryString = queryString.stringify(options, { skipNull: true });
    return SuperFetchV2.get(`/members/${userId}/grade-histories?${gradeHistoriesOptionQueryString}`);
  },

  /**
   * [유저] 유저 리스트 요청하기
   * */
  getAccountUserList: (options: GetAccountUserListParameterType): Promise<AccountUserListResponseType> => {
    const userListOptionQueryString = queryString.stringify(options, { skipNull: true });
    return SuperFetchV2.get(`/members?${userListOptionQueryString}`);
  },

  /**
   * [유저] 유저 정보 이관 요청하기
   * */
  migrateMember: (payload: MemberMigrationRequestOptionType): Promise<MemberMigrationResponseType> => {
    return SuperFetchV2.post('/member-migrations', payload);
  },

  /**
   * [유저] 유저 상세 유저 정보 요청하기
   */
  getAccountUserDetail: (userId?: number): Promise<{ user: AccountUserDetailTypeV2 }> =>
    SuperFetchV2.get(`/members/${userId}`),

  /**
   * [유저] 유저 리스트 엑셀 다운로드 요청
   */
  requestDownloadExcelUserList: (
    filterOptions: UserListFilterOptionType,
  ): Promise<DownloadExcelUserListResponseType> => {
    const userListFilterOptionQueryString = queryString.stringify(filterOptions, { skipNull: true });
    return SuperFetchV2.get(`/files/excel-download/members?${userListFilterOptionQueryString}`);
  },
};
